export default __webpack_public_path__ + "static/media/Sell-Withdraw - Icon.bc30b2dd.svg";